import { render } from "./CustomerTrailerList.vue?vue&type=template&id=6c93828f&scoped=true&ts=true"
import script from "./CustomerTrailerList.vue?vue&type=script&lang=ts"
export * from "./CustomerTrailerList.vue?vue&type=script&lang=ts"

import "./CustomerTrailerList.vue?vue&type=style&index=0&id=6c93828f&scoped=true&lang=scss"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c93828f"]])

export default __exports__